<h3 *ngIf="title" class="title">{{ title }}</h3>
<ng-container *ngFor="let item of items">
  <a
    *ngIf="item.link"
    [target]="item.openInNewWindow ? '_blank' : ''"
    [href]="item.link"
    class="btn btn-block btn-hero btn-iconed btn-iconed-anthrazit-08-primary btn-iconed-left"
  >
    {{ item.title }}
    <ng-container
      *ngTemplateOutlet="arrowIcon; context: { $implicit: item }"
    ></ng-container>
  </a>
  <a
    *ngIf="!item.link"
    (click)="item?.action()"
    class="btn btn-block btn-hero btn-iconed btn-iconed-anthrazit-08-primary btn-iconed-left"
  >
    {{ item.title }}
    <ng-container
      *ngTemplateOutlet="arrowIcon; context: { $implicit: item }"
    ></ng-container>
  </a>
</ng-container>

<ng-template #arrowIcon let-item>
  <i
    aria-hidden="true"
    [class]="item.iconClasses"
    *ngIf="item.iconClasses; else iconContent"
  ></i>
  <i aria-hidden="true" class="ml-auto ifc-custom ifc-arrow-right"></i>
</ng-template>

<ng-template #iconContent>
  <i aria-hidden="true" class="btn-icon">
    <ng-content></ng-content>
  </i>
</ng-template>
